import React from "react";
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import FormSH from '../../../library/form/components/FormSH';
import FormWrapper from '../../../library/form/components/FormWrapper';


import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";
import DocAdminInfo from "../../cmn/DocAdminInfo";

const InvTrnHeader1Viewer = (props) => {
    const { formObject } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Transaction Details' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} rowKey="" 
                        confirm="Are you sure all data is correct ?"
                        action={{ actionId: "refresh", refreshMode:"dep", 
                        actionMessage: "PleaseWait",
                        paramName: "odooSynch", actionParam: {actionType: "odoo"}, containerKey: "popup" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Send to Odoo" />}></FormButton>
                    {/* <FormButton formObject={formObject} rowKey="" 
                        confirm="Are you sure all data is correct ?"
                        action={{ actionId: "refresh", refreshMode:"dep", 
                        actionMessage: "PleaseWait",
                        paramName: "", actionParam: {actionType: "odoo"}, containerKey: "popup" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Payment Status" />}></FormButton>
                    <FormButton formObject={formObject} rowKey="" 
                        confirm="Are you sure all data is correct ?"
                        action={{ actionId: "refresh", refreshMode:"dep", 
                        actionMessage: "PleaseWait",
                        paramName: "", actionParam: {actionType: "odoo"}, containerKey: "popup" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Last 5 Payments" />}></FormButton> */}
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} >

                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} value="Category" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" wrapperClass="uiGridRow135" formObject={formObject} rowKey="" action={{ paramName: "profileName" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileName" }} value="Customer" />
                                </span>
                                <div className="uiVal">
                                    <div className="uiLabelWithAction">
                                        <span className="uiLWALabel" >
                                            <FormLink formObject={formObject} rowKey="" className="uiLink"
                                                action={{
                                                    paramName: "profileName",
                                                    actionId: "show",  actionName: "proComp",
                                                    containerKey: "popup"
                                                }}
                                                linkProp={{ target: "_blank" }}
                                            ></FormLink>
                                        </span>
                                        <span className="uiLWAAction">
                                            <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "profileSHEditContainer" }} >
                                                <FormSH formObject={formObject} rowKey="" 
                                                    action={{ actionId: "edit", paramName: "profileName",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                                ></FormSH>
                                            </FormWrapper>
                                        </span>
                                    </div>
                                </div>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} value="From Location" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} className='uiVal' />
                            </FormWrapper >
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} value="To Location" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} className='uiVal' id="trfToLoc" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "inchrgUser" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inchrgUser" }} value="Incharge User" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "inchrgUser" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "secondaryBeneficiary" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "secondaryBeneficiary" }} value="Support Staff" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "secondaryBeneficiary" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "transCat" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "transCat" }} className='uiVal' id="sTransCatv" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} value="Required On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} className='uiVal' />
                            </FormWrapper>

                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "comment" }} className='uiVal' id="scmtv" />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} className='uiVal' />
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refExDate" }} className='uiVal uiBold uiSpacerL10' />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInNo" }} value="Ref. No (In)" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refInNo" }} className='uiVal'/>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refInDate" }} className='uiVal uiBold uiSpacerL10'/>
                            </li>
                        </ul >

                        <ul>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} value="Budget Code" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} value="Cost Center" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" wrapperClass="uiGridRow135" formObject={formObject} rowKey="" action={{ paramName: "billingProfile" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billingProfile" }} value="" />
                                </span>
                                <div className="uiVal">
                                    <div className="uiLabelWithAction">
                                        <span className="uiLWALabel" >
                                            <FormLink formObject={formObject} rowKey="" className="uiLink"
                                                action={{
                                                    paramName: "billingProfile",
                                                    actionId: "show",  actionName: "proComp",
                                                    containerKey: "popup"
                                                }}
                                                linkProp={{ target: "_blank" }}
                                            ></FormLink>
                                        </span>
                                        <span className="uiLWAAction">
                                            <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "profileSHEditContainer" }} >
                                                <FormSH formObject={formObject} rowKey=""
                                                    action={{ actionId: "edit", paramName: "billingProfile",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                                ></FormSH>
                                            </FormWrapper>
                                        </span>
                                    </div>
                                </div>
                            </FormWrapper>

                            <FormWrapper customWrapper="li" wrapperClass="uiGridRow135" formObject={formObject} rowKey="" action={{ paramName: "billAdd" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billAdd" }} value="Billing Address" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "billAdd" }} className='uiVal' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" wrapperClass="uiGridRow135" formObject={formObject} rowKey="" action={{ paramName: "deliverProfile" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deliverProfile" }} value="" />
                                </span>
                                <div className="uiVal">
                                    <div className="uiLabelWithAction">
                                        <span className="uiLWALabel" >
                                            <FormLink formObject={formObject} rowKey="" className="uiLink"
                                                action={{
                                                    paramName: "deliverProfile",
                                                    actionId: "show",  actionName: "proComp",
                                                    containerKey: "popup"
                                                }}
                                                linkProp={{ target: "_blank" }}
                                            ></FormLink>
                                        </span>
                                        <span className="uiLWAAction">
                                            <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "profileSHEditContainer" }} >
                                                <FormSH formObject={formObject} rowKey="" 
                                                    action={{ actionId: "edit", paramName: "deliverProfile",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                                ></FormSH>
                                            </FormWrapper>
                                        </span>
                                    </div>
                                </div>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" wrapperClass="uiGridRow135" formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "" }} value="Delivery Address" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} className='uiVal' />
                            </FormWrapper>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent >
        </UiView >
    )
}

export default withView(InvTrnHeader1Viewer, "invTrnHeader", "apiLog")
